import { render, staticRenderFns } from "./marketing-report.vue?vue&type=template&id=234e7023&scoped=true&"
import script from "./marketing-report.vue?vue&type=script&lang=js&"
export * from "./marketing-report.vue?vue&type=script&lang=js&"
import style0 from "./marketing-report.vue?vue&type=style&index=0&id=234e7023&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234e7023",
  null
  
)

export default component.exports